import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
import { BaseSearchModel } from '../../../../Data/Models/Common/base-search-model';
import { SoFAModal } from '../../../../Data/Models/Common/SoFA-Model';

@Injectable({
  providedIn: 'root'
})
export class SofaService {
  constructor(private configService: ConfigurationService, private http: HttpClient) { }
  private apiUrl = this.configService.getAPIBaseUrl();

  getStatementofFinancialActivities(Flag: any, PeriodID: any, UserId: any, CentralUser: any, charityId: any): Observable<any> {
    debugger
    const url = this.apiUrl + '/StatementofFinancialActivities/GetStatementofFinancialActivities?Flag=' + Flag + '&PeriodID=' + PeriodID + '&UserId=' + UserId + '&CentralUser=' + CentralUser + '&charityId=' + charityId + ''
    return this.http.get(url);
  }

  SaveStatementOfActivities(modal: SoFAModal): Observable<any> {
    debugger
    const url = `${this.apiUrl}/StatementofFinancialActivities/SaveStatementofFinancialActivities`;
    return this.http.post(url, modal);
  }
}
